import React from "react";
import { Navigate } from "react-router-dom";

import DashboardLayout from "../layouts/DashboardLayout";
import Dashboard from "../pages/dashboard";
import Home from "./../pages/home/index";
import Login from "./../pages/Login/index";



import Logs from "../pages/relatorios/logs";

import RecursosHumanos from "../pages/arquivosFuncionarios";
import OpenFolderEmployee from "../pages/arquivosFuncionarios/openFolderEmployee";
import CategoriasDeArquivos from "../pages/categorias_arquivos";
import Contabil from "../pages/contabil";
import Empresas from "../pages/empresas/index";
import Enderecos from "../pages/enderecos";
import Funcionarios from "../pages/funcionarios/index";
import EsqueciSenha from "../pages/Login/resetSenha";
import SenhaLinkRecebido from "../pages/Login/resetSenha/linkRecebido";
import AddFuncionario from '../pages/operador/adicionar_funcionario/index';
import Grupos from '../pages/operador/grupos/index';
import OpenGrupo from '../pages/operador/grupos/openGrupo/index';
import UserGroups from '../pages/operador/grupos/openGrupo/usuarios/index';
import ViewGrupo from '../pages/operador/grupos/viewGrupo/index';
import TiposDeArquivos from "../pages/tipos_de_arquivos";
import Usuarios from "../pages/usuarios/index";
import VinculoPessoaEmpresa from "../pages/vinculo_pessoa_empresa/index";


const routes = [
  {
    path: "/app",
    element: <DashboardLayout />,
    children: [
      { path: "/home", element: <Home /> },
      { path: "/dashboard", element: <Dashboard /> },
      { path: "*", element: <Navigate to="/app/home" /> },


      { path: "/contabil", element: <Contabil /> },


      { path: "/rh", element: <RecursosHumanos /> }, 
      { path: "/rh/arquivos/:idFuncionario", element: <OpenFolderEmployee /> }, 


,
  


      { path: "/operador/grupos", element: <Grupos /> },
      { path: "/operador/grupos/view", element: <ViewGrupo /> },
      { path: "/operador/grupos/open", element: <OpenGrupo /> },
      { path: "/operador/grupos/open/users", element: <UserGroups /> },
      { path: "/operador/addfuncionario", element: <AddFuncionario /> },


      { path: "/usuarios", element: <Usuarios /> },
      { path: "/funcionarios", element: <Funcionarios /> },
      { path: "/empresa", element: <Empresas /> },
      { path: "/categoria-arquivos", element: <CategoriasDeArquivos /> },
      { path: "/tipo-arquivos", element: <TiposDeArquivos /> },
      { path: "/enderecos", element: <Enderecos /> },
      { path: "/vinculo", element: <VinculoPessoaEmpresa /> },


      { path: "/relatorios/logs", element: <Logs /> },
    ],
  },

  {
    path: "/",
    children: [
      { path: "/", element: <Navigate to="/login" /> },
      { path: "/login", element: <Login /> },
      { path: "/esqueci", element: <EsqueciSenha /> },
      { path: "/recuperar-senha/:hash", element: <SenhaLinkRecebido /> },
    ],
  },
];

export default routes;
